import React from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faImage, 
  faPalette, 
  faMusic, 
  faEye,
  faFileExport,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import './css/ProgressStepper.css';

const ProgressStepper = ({ sessionId }) => {
  const location = useLocation();
  
  const steps = [
    { 
      id: 1, 
      name: 'Upload Image', 
      shortName: 'Image',
      icon: faImage, 
      path: sessionId ? `/app/session/${sessionId}/images` : '/images'
    },
    { 
      id: 2, 
      name: 'Background Color', 
      shortName: 'Colour',
      icon: faPalette, 
      path: sessionId ? `/app/session/${sessionId}/colours` : '/colours'
    },
    { 
      id: 3, 
      name: 'Select Audio Clip', 
      shortName: 'Audio',
      icon: faMusic, 
      path: sessionId ? `/app/session/${sessionId}/audio` : '/audio'
    },
    { 
      id: 4, 
      name: 'Preview Your Design', 
      shortName: 'Preview',
      icon: faEye, 
      path: sessionId ? `/app/session/${sessionId}/preview` : '/preview'
    },
    { 
      id: 5, 
      name: 'Export Your Video', 
      shortName: 'Export',
      icon: faFileExport, 
      path: sessionId ? `/app/session/${sessionId}/export` : '/export'
    }
  ];

  const getCurrentStep = () => {
    const path = location.pathname;
    if (path.includes('/images')) return 1;
    if (path.includes('/colours')) return 2;
    if (path.includes('/audio')) return 3;
    if (path.includes('/preview')) return 4;
    if (path.includes('/export')) return 5;
    return 0;
  };

  const currentStep = getCurrentStep();

  return (
    <div className="progress-stepper">
      <div className="stepper-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`step ${currentStep === step.id ? 'active' : ''} ${currentStep > step.id ? 'completed' : ''}`}>
              <div className="step-icon">
                {currentStep > step.id ? (
                  <FontAwesomeIcon icon={faCheck} />
                ) : (
                  <FontAwesomeIcon icon={step.icon} />
                )}
              </div>
              <div className="step-label">{step.shortName}</div>
            </div>
            {index < steps.length - 1 && (
              <div className={`step-connector ${currentStep > step.id ? 'completed' : ''}`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressStepper;
